import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BatchCreate } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batch: BatchCreate;
}

export const useCreateBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batch }: HookProps) => {
      const formData = new FormData();
      if (batch.file) {
        formData.append('file', batch.file);
        formData.append('name', batch.name);
        formData.append('customer', batch.customer);
        formData.append('template', batch.template);
        formData.append('brokerId', batch.broker || '');
        formData.append('hvSplittingCustomer', batch.hvSplittingCustomer || '');
        formData.append('hvSplittingTemplate', batch.hvSplittingTemplate || '');

        return request({
          path: 'batches/add',
          method: 'POST',
          authenticate: true,
          dataObject: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`New batch was uploaded, it's in the processing queue now!`);
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error uploading the batch!');
    },
  });
};
